import MomentUtils from '@date-io/moment'
import { withStyles } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import { Auth as AuthProvider, loginRoutes, PrivateRoute } from 'elentari'
import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import React, { useCallback, useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import ChatCard from './modules/Chats/ChatCardEmbarcador'
import { ConfiguracoesContext } from './modules/Configuracoes/ConfiguracoesContext'
import { ConsultaFicha } from './modules/ConsultaFicha'
import usuariosRepository from './modules/Usuarios/UsuariosRepository'
import Home from './modules/Home'
import { Login, VerifyLogin } from './modules/Login'
import LoginBase from './modules/Login/LoginBase'
import { AbilityContext, abilityFor } from './modules/Usuarios'
import api from './services/Api'
import theme from './Theme'
import { getUsuarioRealm } from './utils/Utils'
import { BRAND } from './branding'

const styles = () => ({
  '@global': {
    '*::-webkit-scrollbar': {
      height: '0.6em',
      width: '0.6em'
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey'
    }
  }
})

const App = () => {
  useEffect(() => {
    const faviconUrl = `/favicons/${BRAND.label}-favicon.ico`

    document
      .querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")
      .forEach(el => el.remove())

    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = faviconUrl
    link.type = 'image/x-icon'
    document.head.appendChild(link)
  }, [])


  const [user, setUser] = useState()
  const [ability, setAbility] = useState()
  const [tempoMaximoInatividade, setTempoMaximoInatividade] = useState(
    1000 * 60 * 30
  )

  const getTempoInatividade = useCallback(async () => {
    if (user) {
      const response = await api.getConfigValue('TEMPO_SESSAO_USUARIO')
      if (response.ok) {
        setTempoMaximoInatividade(+response.data.valor * 1000 * 60) // transforma para minutos
      }
    }
  }, [user])

  const updateUser = useCallback(async () => {
    let idInterval
    if (user) {
      idInterval = setInterval(async () => {
        const userInfo = await api.getUserInfo()
        const currentUserRealm = getUsuarioRealm()
        if (userInfo.ok && userInfo.data.realm !== currentUserRealm) {
          setAbility(abilityFor(userInfo.data))
        }
      }, 60000)
    }

    return () => {
      clearInterval(idInterval)
    }
  }, [user])

  useEffect(() => {
    // updateUser()
    getTempoInatividade()
  }, [updateUser, getTempoInatividade])

  const withUser = async user => {
    api.setToken(user.token)
    const usuarioAtualizado = await usuariosRepository.getMe()
    setUser(usuarioAtualizado)
    setAbility(abilityFor(usuarioAtualizado))
  }

  return (
    <ThemeProvider theme={theme}>
      <AbilityContext.Provider value={[ability, setAbility]}>
        <ConfiguracoesContext.Provider value={tempoMaximoInatividade}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <AuthProvider withUser={withUser} onLogout={api.logout}>
              <VerifyLogin />
              <Router>
                <Switch>
                  <Route path={loginRoutes.login} component={Login} />
                  <Route path="/callback" component={LoginBase} />
                  <Route path="/chat/embarcador/:token" component={ChatCard} />
                  <Route path="/consultaFicha" component={ConsultaFicha} />
                  <PrivateRoute path="/" render={() => <Home user={user} />} />
                </Switch>
              </Router>
            </AuthProvider>
          </MuiPickersUtilsProvider>
        </ConfiguracoesContext.Provider>
      </AbilityContext.Provider>
    </ThemeProvider>
  )
}

export default withStyles(styles)(App)
